import { useEffect } from "react";
import { APP_TITLE, PUBLIC_PAGE_META } from "./page-meta";

/** 화면이 바뀔 때 문서 제목을 맞춘다. 공개 페이지는 page-meta.ts의 값, 그 밖엔 서비스 이름. */
export function usePageMeta(path: string, fallbackTitle?: string) {
  useEffect(() => {
    document.title = PUBLIC_PAGE_META[path]?.title ?? (fallbackTitle ? `${fallbackTitle} · ${APP_TITLE}` : APP_TITLE);
  }, [path, fallbackTitle]);
}
